import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EmployeeMasterService }  from '../../shared/HR_ADMIN/Employee/EmployeeMaster.Service';
import { BirthDayAnniversaryModel }  from '../../shared/HR_ADMIN/Employee/BirthDayAnniversaryModel.Model';
import { UserService } from '../../shared/user.service';
import { Menu } from '../../shared/menu.model';
import { ModalOptions,BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-manage-birthday',
  templateUrl: './manage-birthday.component.html',
  styleUrls: ['./manage-birthday.component.css']
})

export class ManageBirthdayComponent implements OnInit 
{
  BirthDayAnniversaryModel : BirthDayAnniversaryModel= new BirthDayAnniversaryModel();
  userClaims: any;
  BirthDays: BirthDayAnniversaryModel[] = [];
  Birthday: any;
  public tableWidget: any;
  // Begning Permission Portion    
  SelectedMenu:Menu;
  IsDataIsInViewState : boolean=false;
  CanViewState : boolean=false;
  DisableSave :boolean=false;
  // End of the permission portion
  SubMenues : Menu[]=[];
  Mod : any;
  //For Pop up
  ShowPopup : boolean= false;
  MsgSent : boolean= false;
  MsgnotSent : boolean= false;
  public modalRef: BsModalRef;
  public modelopt:ModalOptions;
  RefId: any;

  constructor(private EmployeeMasterService: EmployeeMasterService, private rout: Router, private userService: UserService,private modalService: BsModalService)
  {
    this.modelopt=new ModalOptions();
    this.modelopt.class='heavy_modal';
    this.modalService.config= this.modelopt;
    this.modelopt.ignoreBackdropClick=true;
  }

  ngOnInit() 
  {
    // Begning Permission Portion 
    this.SubMenues=[];
    let t =  localStorage.getItem('userToken');
    t = 'Bearer' + t;
    let menuid = localStorage.getItem("menuidstor");
    this.userService.GetSubMenuList( t, menuid).then(x => 
    {
      this.Mod = x;
      Object.keys(this.Mod).forEach( key => 
      {
        // tslint:disable-next-line:no-unused-expression
        this.Mod[key];
        let menutemp = new Menu();
        menutemp = this.Mod[key];
        this.SubMenues.push(menutemp);
      });
      this.userService.SelectedMenu= this.SubMenues[0];
      this.rout.navigate([this.userService.SelectedMenu.RouteName]);
      this.SelectedMenu=this.userService.SelectedMenu;
      if(this.SelectedMenu.CanAdd)
      {
        this.IsDataIsInViewState=false;
      }
      else
      {
        this.IsDataIsInViewState=true;
      }
      if(this.SelectedMenu.CanView)
      {
        this.CanViewState=false;
      }
      else
      {
        this.CanViewState=true;
      }
    });
    // End of the permission portion
    this.ShowPopup=false;
    this.DisableSave=true; 
    var CurrentDate = new Date();
    var CurrentYear = CurrentDate.getFullYear();
    var currentMonth = CurrentDate.getMonth();
    var CurrentDay = CurrentDate.getDate();
    var CDate = CurrentYear + '-' + (currentMonth+1) +'-'+ CurrentDay;
    this.BirthDayAnniversaryModel.DOB=CurrentDate;
    this.GetEmployeeBirtDay(CDate);    
  }

  GetEmployeeBirtDay(DOB)
  {
    this.BirthDays =[];
    let t =  localStorage.getItem('userToken');
    t = 'Bearer' + t;
    this.EmployeeMasterService.GetEmployeeBirtDay( t,DOB).then(x => 
    {
      this.Birthday = x;
      Object.keys(this.Birthday).forEach( key => 
      {
        this.Birthday[key];
        let Expensetemp = new BirthDayAnniversaryModel();
        Expensetemp = this.Birthday[key];
        this.BirthDays.push(Expensetemp);
      });
    });
  }

  DateChanged( date)
  {
    this.GetEmployeeBirtDay(date);
  }

  ViewBirthDayDetailsForMail(Id,Name,EmployeeEmailId,template) 
  {
    if(this.ShowPopup==true)
    {
      this.modalRef.hide();
    }
    this.modalRef = this.modalService.show(template,this.modelopt);
    this.ShowPopup=true;
    this.BirthDayAnniversaryModel.EmployeeCode=Id;
    this.BirthDayAnniversaryModel.EmployeeName=Name;
    this.BirthDayAnniversaryModel.EmployeeEmailId=EmployeeEmailId;
    this.BirthDayAnniversaryModel.Message=null;
  }

  BirthDayMailFarward(template) :void
  {
    this.DisableSave=false;
    let t =  localStorage.getItem('userToken');
    t = 'Bearer' + t;
    this.EmployeeMasterService.BirthDayMailFarward(t ,this.BirthDayAnniversaryModel).subscribe(res=>
    {
      this.RefId=res;
      this.BirthDayAnniversaryModel.EmployeeId=0;  
      if(this.RefId>0)
      {
        this.modalRef.hide();
        this.ShowPopup=false;
        this.MsgSent=true;
        this.MsgnotSent=false;
        this.modalRef = this.modalService.show(template);
      }
      else
      {
        this.modalRef.hide();
        this.ShowPopup=false;
        this.MsgSent=false;
        this.MsgnotSent=true;
        this.modalRef = this.modalService.show(template);
      }
    });
  }
}